import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import moment from 'moment';
import { get } from 'lodash';

const useStyles = makeStyles(() => ({
  inline: {
    display: 'inline',
  },
  readColumn: {
    width: 80,
    marginTop: 30,
    fontSize: 8,
  },
  callToAction: { float: 'right' },
  time: {
    position: 'absolute',
    bottom: 20,
  },
  avatar: {
    backgroundColor: '#1396e2',
  },
}));

export const AutoMailerUserNotification = props => {
  const { notification } = props;
  const classes = useStyles();
  const dataString = get(notification, 'data', '{}');
  const data = JSON.parse(dataString);
  const readCol = !get(notification, 'readAt') ? (
    <div className={classes.readColumn}>&#128313;</div>
  ) : (
      <div className={classes.readColumn}>&nbsp;</div>
    );

  return (
    <ListItem alignItems="flex-start">
      <ListItemText>{readCol}</ListItemText>
      <ListItemAvatar>
        <Avatar
          className={classes.avatar}
          name={get(notification, 'notifiableType')}>      
          <FormattedMessage id="notifications.ec" />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={<>Check out the new resource {get(notification, 'notifiable.title')}</>}
        secondary={
          <>
            <span className={classes.time}>
              {get(notification, 'createdAt') &&
                moment(notification.createdAt).fromNow()}
            </span>
            <Button href="/media" className={classes.callToAction}>
              <FormattedMessage id="notifications.browse_now" />
            </Button>
          </>
        }
      />
    </ListItem>
  );
};

AutoMailerUserNotification.propTypes = {
  notification: PropTypes.object.isRequired,
};

export default AutoMailerUserNotification;
